import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/custom';
import custom from '@/custom';
import codes from '@/codes';
import vSelect from 'vue-select';
import { Switch as cSwitch } from '@coreui/vue';

//restful api
import { policy as webcastle } from '@/service/api/webcastle'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: '', opt : {}, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', sortable: true, label: '#.', thStyle: 'width: 5%',},
    { key: 'is_alive', sortable: false, label: 'Status', thStyle: 'width: 10%',},
    { key: 'count', sortable: false, label: 'Count', thStyle: 'width: 10%',},
    { key: 'version', sortable: false, label: 'Version'},
    { key: 'agent_version', sortable: false, label: 'Minimum Agent Version'},
    { key: 'updated_at', sortable: true, label: 'Last modified date' },
  ],
  KO: [
    { key: 'id', sortable: true, label: '#.', thStyle: 'width: 5%',},
    { key: 'is_alive', sortable: false, label: '상태', thStyle: 'width: 10%',},
    { key: 'count', sortable: false, label: '횟수', thStyle: 'width: 10%',},
    { key: 'version', sortable: false, label: '버전'},
    { key: 'agent_version', sortable: false, label: '에이전트 최소 버전'},
    { key: 'updated_at', sortable: true, label: '최종 수정일' },
  ]
}

export default {
  components: { DatePicker, vSelect, cSwitch },
  props : ["auto_refresh", "enable_new", "view_detail"],
  name : "MailList",
  data: () => ({
    partner_name : '',
    chainPartner : false,
    custom,
    codes,
    datepicker,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
    nbsp : "\u00A0",
    hide_del : true,
  }),
  filters: {
    level(v) {
      return v;
    }
  },
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    last_version() {

    },
    setGroup(item) {
      console.log("partner info", item.username, item.id)
      this.so.opt['partner_id'] = item.id
      this.partner_name = item.username;
      this.chainPartner = false;
      this.refresh()
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['updated_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(['partner_id', 'category_code', 'target_code'].indexOf(k) > -1) {
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == false || v == true) { // 컨버팅 필요
        return { name : k, value : v === false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.th) { clearTimeout(this.th); this.th = undefined; }
      if(!this.th && this.sync.stop) { this.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_alive':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'is_del':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = this.set_op(k[i], this.so.opt[k[i]].meta.value);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.e("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.e("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
        return webcastle.listPolicy(so).then(rs => {
        this.so.totalRows = rs.total;
        console.log("WTF", rs.body)
        return rs.body ? rs.body : [];
      }).catch(e => {
        console.log(e)
        this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText)
      });
    },
    summary() {
      webcastle.summaryPolicy({ ts : new Date().getTime() } )
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : (rs.body.total - rs.body.enable), total : rs.body.total }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail(item) {
      if(this.view_detail === false) { this.$root.$emit("select", item); }
      else {
        this.$router.push({ name : 'webcastle_policy', params : { id : item.id } });
      }
    },
  },
  created() { console.log('Policy_list.vue', 'created'); this.$root.$on('select', this.setGroup) },
  destroyed() { console.log('Policy_list.vue', 'destroyed'); },
  mounted() {
    console.log('Policy_list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}